// helpers.ts — Pure utility functions for J203 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Format number with 3 decimals (for unit price) */
export const fmtPrice = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 3 });
};

/** Invoice type label mapping */
export const invoiceTypeLabel = (v: number): string => {
  switch (v) {
    case 1: return '三聯式';
    case 2: return '二聯式';
    case 3: return '免開';
    default: return '未選';
  }
};

/** Approval status label
 *  統一狀態碼（規格法定值）：N=草稿/已沖銷、D=送審中、P=已核准
 *  （自創碼 S/R/V 已廢除；S 保留映射僅供顯示殘留舊值） */
export const approvalLabel = (v: string): string => {
  switch (v) {
    case 'P': return '已核准';
    case 'D': return '送審中';
    case 'S': return '送審中(舊碼)';
    case 'N': return '草稿';
    default: return '草稿';
  }
};

/** Approval status badge color */
export const getApprovalBadge = (status: string): { color: string; label: string } => {
  switch (status) {
    case 'P': return { color: '#52c41a', label: '已核准' };
    case 'D': return { color: '#faad14', label: '送審中' };
    case 'S': return { color: '#faad14', label: '送審中(舊碼)' };
    default: return { color: '#d9d9d9', label: '草稿' };
  }
};

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  const alwaysReadonly = new Set([
    'fj130_01', 'fj130_19', 'fj130_22', 'fj130_80', 'fj130_81',
    'fj130_90', 'fj130_91', 'fj130_92',
  ]);
  if (alwaysReadonly.has(key)) return true;
  return false;
};
